/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-unused-vars */
import apiForm from '@/services/jApiForm';

const state = {
  form_list: [],
  form_data: null,
  form_id: null,
  form_name: 'Create Data Manager',
  form_length: null,
  form_index: null,
  form_changed: false,
  group_data_list: [],
  table_by_group_list: [],
  privilege_by_group_data_list: [],
  privilege_by_me: [],
  archive_id: null,
  purging_data: null,
  audit_log_list: [],
  archive_data_list: null,
};

const mutations = {
  addListForm(state, data) {
    state.form_list = state.form_list.concat(data);
  },
  setListForm(state, data) {
    state.form_list = data;
  },
  setFormData(state, data) {
    state.form_data = data;
  },
  setFormId(state, id) {
    state.form_id = id;
  },
  setFormName(state, name) {
    state.form_name = name;
  },
  setFormIndex(state, index) {
    state.form_index = index;
  },
  setFormLength(state, length) {
    state.form_length = length;
  },
  dataCreated(state) {
    state.form_changed = !state.form_changed;
  },
  setListGroupData(state, data) {
    state.group_data_list = data;
  },
  setListTableByGroup(state, data) {
    state.table_by_group_list = data;
  },
  setListPrivilegeByGroupData(state, data) {
    state.privilege_by_group_data_list = data;
  },
  setListPrivilegeByMe(state, data) {
    state.privilege_by_me = data ? data.privilege : [];
  },
  setArchiveId(state, data) {
    state.archive_id = data;
  },
  setPurgingData(state, data) {
    state.purging_data = data;
  },
  setAuditLogList(state, data) {
    state.audit_log_list = data;
  },
  setArchiveDataList(state, data) {
    state.archive_data_list = data;
  },
};

const actions = {
  async createForm({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.createForm(data.param);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');
      const dataFilter = {
        company_id: data.session.user.company_id,
      };
      const reqData = {
        page: 1,
        limit: 1000000,
        filter: JSON.stringify(dataFilter),
        sort: JSON.stringify({ updated_at: -1 }),
      };
      dispatch('getListForm', reqData);
    } catch (err) {
      res = err.response.data;
      // dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      // dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async updateForm({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.createForm(data.param);
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      // dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });

      if (data.data) {
        const columnName = data.dataold ? data.dataold.name : '';
        res = await apiForm[`${data.action}Column`](data.data, data.param.id, columnName);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      }
      const dataFilter = {
        company_id: data.session.user.company_id,
      };
      const reqData = {
        page: 1,
        limit: 1000000,
        filter: JSON.stringify(dataFilter),
        sort: JSON.stringify({ updated_at: -1 }),
      };
      dispatch('getListForm', reqData);
    } catch (err) {
      res = err.response.data;
      // dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      // dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async createRecord({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.createRecord(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async deleteForm({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.deleteForm(data.param);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');
      const dataFilter = {
        company_id: data.session.user.company_id,
      };
      const reqData = {
        page: 1,
        limit: 1000000,
        filter: JSON.stringify(dataFilter),
        sort: JSON.stringify({ updated_at: -1 }),
      };
      dispatch('getListForm', reqData);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data, { root: true });
    }
    return res;
  },

  async truncateForm({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.truncateForm(data.param);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');
      // const dataFilter = {
      //   company_id: data.session.user.company_id,
      // };
      // const reqData = {
      //   page: 1,
      //   limit: 1000000,
      //   filter: JSON.stringify(dataFilter),
      //   sort: JSON.stringify({ updated_at: -1 }),
      // };
      // dispatch('getListForm', reqData);

      const reqTable = {
        tablegroup_id: data.paramGroup.tablegroup_id || 'legacy',
        search: '',
      };
      dispatch('getListTableByGroup', reqTable);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data, { root: true });
    }
    return res;
  },

  async deleteRecord({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.deleteRecord(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async getListForm({ commit, dispatch }, data) {
    let resData;
    try {
      resData = await apiForm.listForm(data);
      commit('setListForm', resData.data);
      commit('setFormLength', resData.length);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return resData;
  },

  async getListPosition({ dispatch }, { reqData, callback }) {
    try {
      const resData = await apiForm.getListPosition(reqData);
      const res = resData.data ? resData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListRule({ dispatch }, { reqData, callback }) {
    try {
      const resData = await apiForm.getListRule(reqData);
      const res = resData.data ? resData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  actionSetFormData({ commit }, data) {
    commit('setFormData', data);
  },

  actionSetForm({ commit }, id) {
    const formId = id;
    commit('setFormId', formId);
  },

  actionSetNameForm({ commit }, name) {
    const formName = name;
    commit('setFormName', formName);
  },

  actionSetFormIndex({ commit }, index) {
    commit('setFormIndex', index);
  },

  async findDataRecord({ dispatch }, data) {
    let res;
    try {
      res = await apiForm.getListRecordByFormDataId(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async findRule({ dispatch }, data) {
    let res;
    try {
      res = await apiForm.getListRule(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async findFormData({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.getFormData(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getCountDataRecord({ dispatch }, data) {
    let res;
    try {
      res = await apiForm.getCountRecordFormData(data);
      if (res.error || res.error_session) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      }
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  // Data Group
  async getListDataGroupByCompanyId({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiForm.listDataGroupByCompanyId();
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListDataGroup({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiForm.listDataGroup(data);
      commit('setListGroupData', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListDataGroupAsync({ dispatch }, { reqData, callback }) {
    try {
      const resData = await apiForm.listDataGroup(reqData);
      const res = resData.data ? resData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
  },

  async createDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.createDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async updateNameDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.updateNameDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async updateDescDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.updateDescDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async deleteDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.deleteDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListTableByGroup({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiForm.listTableByGroup(data);
      commit('setListTableByGroup', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListTableByGroupV2({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiForm.listTableByGroupV2(data);
      commit('setListTableByGroup', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async findListTableByGroup({ dispatch }, data) {
    let res;
    try {
      res = await apiForm.listTableByGroup(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async assignDataGroup({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.assignDataGroup(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  // Data Privilege
  async getListPrivilegeByGroup({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiForm.listPrivilegeByGroup(data);
      commit('setListPrivilegeByGroupData', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListPrivilegeByUser({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiForm.listPrivilegeByUser(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListPrivilegeByMe({ commit, dispatch }, data) {
    let res;
    try {
      res = await apiForm.listPrivilegeByMe(data);
      commit('setListPrivilegeByMe', res.data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async addPrivilege({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.addPrivilege(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async removePrivilege({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.removePrivilege(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async deletePrivilege({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.deletePrivilege(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  // Form Data New
  async createTable({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.createTable(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');

      const reqTable = {
        tablegroup_id: data.tablegroup_id,
        search: '',
      };
      dispatch('getListTableByGroup', reqTable);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async updateTable({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await apiForm.updateTable(data.param);

      if (data.data) {
        const columnName = data.dataold ? data.dataold.name : '';
        res = await apiForm[`${data.action}Column`](data.data, data.param.id, columnName);
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      }

      const reqTable = {
        tablegroup_id: data.param.tablegroup_id || 'legacy',
        search: '',
      };
      dispatch('getListTableByGroup', reqTable);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async deleteTable({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.deleteTable(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('dataCreated');

      const reqTable = {
        tablegroup_id: data.tablegroup_id || 'legacy',
        search: '',
      };
      dispatch('getListTableByGroup', reqTable);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data, { root: true });
    }
    return res;
  },

  async setPrimaryKey({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.setPrimaryKey(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async removePrimaryKey({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let res;
    try {
      res = await apiForm.removePrimaryKey(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListServiceSwitcher({ dispatch }) {
    let res;
    try {
      res = await apiForm.getListServiceSwitcher();
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionServiceSwitcher({ dispatch }, data) {
    let res;
    try {
      res = await apiForm[data.action](data.param);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async requestOtpArchiveData({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await apiForm.requestOtpArchiveData(data);
      if (!res.error && !res.error_session) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        return res.data;
      }
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data, { root: true });
    }
  },

  async requestOtpPurgingData({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await apiForm.requestOtpPurgingData(data);
      if (!res.error && !res.error_session) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        return res.data;
      }
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data, { root: true });
    }
  },

  async archiveData({ commit, dispatch }, { id, data }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await apiForm.archiveData(id, data);
      if (!res.error && !res.error_session) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        commit('setArchiveId', res.data.archive_id);
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data, { root: true });
    }
  },

  async purgingData({ commit, dispatch }, { id, data }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await apiForm.purgingData(id, data);
      if (!res.error && !res.error_session) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        commit('setPurgingData', res.data);
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data, { root: true });
    }
  },

  async getListAuditLogTable({ commit, dispatch }, data) {
    let resData;
    try {
      resData = await apiForm.getListAuditLogTable(data);
      commit('setAuditLogList', resData.data);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return resData.data;
  },

  async getListArchiveData({ commit, dispatch }, data) {
    try {
      const res = await apiForm.getListArchiveData(data);
      if (!res.error) {
        commit('setArchiveDataList', res.data);
        return res.data;
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreForm.js